import React, { useEffect } from 'react'

import {
  ERROR_EEI_SCORE_NOT_ACTIVATED,
  ERROR_EEI_SCORE_NOT_ACTIVATED_DEFAULT_COMMUNITY,
} from 'constants/error-codes'

import { useTranslation } from 'react-i18next'
import { useLocation, useOutletContext, useParams } from 'react-router-dom'

import ActivateEEIDialog from '@components/shared/dialogs/ActivateEEIDialog'
import PurchaseLearnDialog from '@components/shared/dialogs/PurchaseLearnDialog'
import PageLayout from '@components/shared/layout/PageLayout'
import { useDialogStore } from '@stores/dialog.store'

import type { APIError } from '@providers/APIErrorProvider'
import type { SearchConfig } from '@services/SearchService'

const TitleErrorPage: React.FC = () => {
  const openDialog = useDialogStore((s) => s.openDialog)
  const closeDialog = useDialogStore((s) => s.closeDialog)

  const params = useParams()
  const { t } = useTranslation()
  const { searchConfig, errors } =
    useOutletContext<{ searchConfig: SearchConfig; errors: APIError[] }>()

  const code = errors[0].code
  const { pathname } = useLocation()

  useEffect(() => {
    if (
      code === ERROR_EEI_SCORE_NOT_ACTIVATED ||
      code === ERROR_EEI_SCORE_NOT_ACTIVATED_DEFAULT_COMMUNITY
    ) {
      if (pathname.startsWith('/learnpremiumcontent')) {
        openDialog('purchase_learn')
      } else {
        openDialog('activate_eei')
      }
    }
  }, [])

  const afterActivate = (): void => {
    closeDialog('activate_eei')
    window.location.reload()
  }

  return (
    <PageLayout hideFooter searchConfig={searchConfig}>
      <div className="inset-0 flex flex-col items-center h-screen px-2 pt-10 bg-gray-light dark:bg-black-bg">
        {code && (
          <h1 className="w-full mb-2 font-medium text-center text-h3">{t(`errors.${code}`)}</h1>
        )}
      </div>
      {params.id && <ActivateEEIDialog titleUuid={params.id} afterActivate={afterActivate} />}
      <PurchaseLearnDialog />
    </PageLayout>
  )
}

export default TitleErrorPage
